ACC.recaptcha = {
  sitekeyClass: '.ph-sitekey',
  bindCaptcha: function() {
    $(document).on('click', '.ph-captchasubmit', function() {
      var siteKeyVal = $(ACC.recaptcha.sitekeyClass).attr('data-sitekey'),
          registerflag = true,
          actionName = '',
          defaulLoaderClass = '.ph-loader__default';

      $(defaulLoaderClass).show();

      if ($('.template-pages-account-registerPage').length > 0) {
        actionName = 'registration';
      } else if ($('.template-pages-FeedbackPageTemplate').length > 0) {
        actionName = 'feedback';
      } else if ($('.page-anonymousOrderSearch').length > 0) {
        actionName = 'anonymous';
      }

      if ($('.ph-signup__error').hasClass('form_field_error')) {
        registerflag = false;
        $(defaulLoaderClass).hide();

        return false;
      }

      /* eslint-disable no-undef */
      if (!grecaptcha) {
      /* eslint-enable no-undef */

        $(defaulLoaderClass).hide();
      }

      $('.g-recaptcha_action').val(actionName);
      /* eslint-disable no-undef */
      /* eslint-disable promise/catch-or-return */
      grecaptcha.ready(function() {
        grecaptcha.execute(siteKeyVal, {
        /* eslint-enable no-undef */
        /* eslint-enable promise/catch-or-return */
          action: actionName
          /* eslint-disable promise/prefer-await-to-then */
        }).then(function(token) {
        /* eslint-enable promise/prefer-await-to-then */

          $('.g-recaptcha_response').val(token);

          if ($('.ph-signup__error').hasClass('form_field_error')) {
            $(defaulLoaderClass).hide();
            registerflag = false;
          }

          /* eslint-disable promise/always-return */
          if (registerflag === true) {
          /* eslint-enable promise/always-return */
            $(ACC.recaptcha.sitekeyClass).parents('form').submit();
          }
        });
      });

      return true;
    });
  }
};
$(document).ready(function() {
  var siteKeyVal = $(ACC.recaptcha.sitekeyClass).attr('data-sitekey');

  if ($(ACC.recaptcha.sitekeyClass).length > 0) {
    $.getScript('https://www.google.com/recaptcha/api.js?render=' + siteKeyVal);
    ACC.recaptcha.bindCaptcha();
  }
});
